<div class="row">
	<div class="col-12 col-xl-9 order-2">
	<div class="panel panel-default" id="translate"  *ngIf="records">
		<div class="panel-heading">
			<h1 class="d-inline-block" *ngIf="Links">
				{{ 'result' | translate }} :  {{ TotelElements }} - {{ 'page' | translate }} {{ CurrentPage }} / {{ TotalPages }}
			</h1>
			<!-- <div class="px-4 d-inline-block">
				<span class="text-secondary my-2 my-sm-0" >
					<input type="checkbox" (click)="changeShs($event)" [checked]="shs" />
					{{ 'SHS' | translate }} -
				</span>
				<span class="text-secondary my-2 my-sm-0'">
					<input type="checkbox" (click)="changeLmg($event)" [checked]="lmg" />
					{{ 'LMG' | translate }}
				</span>
			</div> -->
		</div>
		<div class="panel-body">
			<div class="tz-gallery col-12 py-2" *ngFor="let r of records">
				<a class=" d-block link-manu">
					<table class="table">
						<thead>
							<tr class="row">
								<th class="col-12 col-md-2 text-center"><br>
									<a target="_blank" [href]="'http://catalog.fondation.org.ma:81/cgi-bin/koha/opac-detail.pl?biblionumber='+r.ckey" 
										class="lightbox d-inline-block w-75" target="_blank">
										<img *ngIf="!r.numctrl_src" [src]="'http://www.fondation.org.ma/assets/images/cover_book/'+r.numctrl+'.jpg'" class="img-thumbnail w-100"
											onerror="this.onerror=null;this.src='http://www.fondation.org.ma/assets/images/icon-book.png';" />
											<img *ngIf="r.numctrl_src" [src]="'http://www.fondation.org.ma/assets/images/cover_book/'+r.numctrl_src+'.jpg'" class="img-thumbnail w-100"
											onerror="this.onerror=null;this.src='http://www.fondation.org.ma/assets/images/icon-book.png';" /> <br /> 
									</a>
									<h2 class="green bold"> 
										<mat-icon *ngIf="r.type === 'book'" >book</mat-icon><mat-icon *ngIf="r.type === 'article' || r.type === 'contribution'" >file_copy</mat-icon>
										 {{ r.type | translate }} </h2><br />
								</th> 
								<th class="col-12 col-md-10 biblio">
									<table class="tab-manu">
										<tbody>
											<tr class="row" *ngIf="r.title">
												<td class="bold col-12 col-md-3">{{ 'titre' | translate }} :</td> 
												<td class="bold col-12 col-md-9">{{ r.title | selectbar : 'a' }} {{ r.title | selectbar : 'n' | replacechar : '/' : '' }} {{ r.title | selectbar : 'p' | replacechar : '/' : '' }}{{ r.title | dotpipeh : '|h' }}{{ r.title | selectbar : 'b'  }}{{ r.title | dotpipeh : '|b' }} {{ r.title | selectbar : 'c' }}</td> 
											</tr> 
											<tr class="row" *ngIf="r.titleoriginal || r.titleparallele || r.titleintermidiaire">
												<td class="bold col-12 col-md-3">{{ 'titre_org' | translate }} :</td> 
												<td class="bold col-12 col-md-9" [ngClass]="{rtl: r.langcible.indexOf('Arabe - العربية')}">
													<p *ngIf="r.titleoriginal && !r.titleintermidiaire"> {{ r.titleoriginal | selectbar : 'a' }} {{ r.titleoriginal | selectbar : 'n'  | replacechar : '/' : '' }} {{ r.titleoriginal | selectbar : 'p'  | replacechar : '/' : '' }} {{ r.titleoriginal | selectbar : 'b' | replacechar : '/' : ''  }} {{ r.titleoriginal | selectbar : 'k' | replacechar : '/' : ''  }}</p>
													<!--<p *ngIf="r.titleparallele"> {{ r.titleparallele | selectbar : 'a' }}  {{ r.titleparallele | selectbar : 'b' | replacechar : '/' : '' }} </p>-->
													<p *ngIf="r.titleintermidiaire"> {{ r.titleintermidiaire | selectbar : 'a' }} {{ r.titleoriginal | selectbar : 'n' | replacechar : '/' : ''  }} {{ r.titleoriginal | selectbar : 'p' | replacechar : '/' : ''  }} {{ r.titleintermidiaire | selectbar : 'b' | replacechar : '/' : '' }} {{ r.titleoriginal | selectbar : 'k' | replacechar : '/' : ''  }}</p>
												</td> 
											</tr> 
											<tr class="row"  *ngIf="r.numctrl_src">
												<td class="col-12 col-md-3">{{ 'in' | translate }} :</td> 
												<td class="col-12 col-md-9"><a class="pointer green bold" (click)="Getsearch(r.author, 'author')">
													{{ r.art_trad | selectbar : 't' | replacechar : '/' : '' }} 
												</a></td> 
											</tr> 
											<tr class="row"  *ngIf="r.numctrl_src && r.pages">
												<td class="col-12 col-md-3">{{ 'pages' | translate }} :</td> 
												<td class="col-12 col-md-9"><a class="pointer green bold" (click)="Getsearch(r.author, 'author')">
													{{ r.pages }} 
												</a></td> 
											</tr> 
											<!-- <tr class="row" *ngIf="r.isbn">
												<td class="col-12 col-md-6">ISBN</td> 
												<td class="col-12 col-md-6">{{ r.isbn | withoutbar }}</td> 
												<td class="text-right col-12 col-md-3">ردمك </td>
											</tr>  -->
											<tr class="row" *ngIf="r.author">
												<td class="col-12 col-md-3">{{ 'auteur' | translate }} :</td> 
												<td class="col-12 col-md-9"><a class="pointer green bold" (click)="Getsearch(r.author, 'author')">
													{{ r.author | selectbarsearch : 'a' : 'ar' }}<br />
													{{ r.author | selectbarsearch : 'a' : 'fr' }} 
												</a></td> 
											</tr> 
											<tr class="row" *ngIf="r.traducteur">
												<td class="col-12 col-md-3">{{ 'traducteur' | translate }} :</td> 
												<td class="col-12 col-md-9"><a class="pointer green bold" (click)="Getsearch(r.traducteur, 'traducteur')">
													{{ r.traducteur | selectbarsearch : 'a' : 'ar' }}<br />
													{{ r.traducteur | selectbarsearch : 'a' : 'fr' }}</a></td> 
											</tr> 
											<!-- <tr class="row" *ngIf="r.reviseur">
												<td class="col-12 col-md-6">Réviseur</td> 
												<td class="col-12 col-md-6"><a class="pointer green bold" (click)="Getsearch(r.reviseur, 'reviseur')">{{ r.reviseur | withoutbar }}</a></td> 
												<td class="text-right col-12 col-md-3">مراجع</td>
											</tr>  -->
											<!-- <tr class="row" *ngIf="r.statementres && r.status==true">
												<td class="col-12 col-md-6">Mention resp.</td> 
												<td class="col-12 col-md-6">{{ r.statementres | withoutbar }}</td> 
												<td class="text-right col-12 col-md-3">بيان المسؤولية</td>
											</tr>  -->
											<!-- <tr class="row" *ngIf="r.paysedition && r.status==true">
												<td class="col-12 col-md-6">Lieu d'édition</td>
												<td class="col-12 col-md-6" >{{ r.paysedition | withoutbar  }}</td>
												<td class="text-right col-12 col-md-3">مكان النشر</td>
											</tr> -->
											<tr class="row" *ngIf="r.editeur">
												<td class="col-12 col-md-3">{{ 'editeur' | translate }} :</td>
												<td class="col-12 col-md-9" ><a class="pointer green bold"  (click)="Getsearch(r.editeur, 'editeur')">{{ r.editeur  | replacechar : 'editor' : '' }}</a></td>
											</tr>
											<tr class="row" *ngIf="r.anneeedition">
												<td class="col-12 col-md-3">{{ 'annee_edition' | translate }} :</td>
												<td class="col-12 col-md-9" >{{ r.anneeedition | withoutbar  }}</td>
											</tr>
											<!-- <tr class="row" *ngIf="r.paysorigine && r.status==true">
												<td class="col-6">Pays d'origine</td>
												<td class="col-6" >{{ r.paysorigine | withoutbar  }}</td>
												<td class="text-right col-3">البلد الأصلي</td>
											</tr> -->
											<!-- <tr class="row" *ngIf="r.langsource && r.status==true">
												<td class="col-6">Langue source</td>
												<td class="col-6" >{{ r.langsource | withoutbar  }}</td>
												<td class="text-right col-3">لغة المصدر</td>
											</tr>
											<tr class="row" *ngIf="r.langcible && r.status==true">
												<td class="col-6">Langue cible</td>
												<td class="col-12 col-md-6" >{{ r.langcible | withoutbar  }}</td>
												<td class="text-right col-12 col-md-3">اللغة الهدف</td>
											</tr> -->
											<tr class="row" *ngIf="r.matiere">
												<td class="col-12 col-md-3">{{ 'thematique' | translate }} :</td> 
												<td class="col-12 col-md-9">
													<a class="pointer green bold {{ 'dara' | translate }}" (click)="Getsearch(r.matiere, 'matiere')">{{ r.matiere | splitsubject : 'ar' }}</a>
													<a class="pointer green bold {{ 'dfre' | translate }}" (click)="Getsearch(r.matiere, 'matiere')">{{ r.matiere | splitsubject : 'fr' }}</a>
												</td> 
											</tr> 
											<tr class="row" *ngIf="r.cote && !r.link && r.cote!='INTRANET'">
												<td class="col-12 col-md-3">{{ 'numero' | translate }} :</td> 
												<td class="col-12 col-md-9 ltr">{{ r.cote | withoutbar }}</td> 
											</tr> 
											<tr class="row" *ngIf="r.link && intra=='true'">
												<td class="col-12 col-md-3">{{ 'lien' | translate }} :</td> 
												<td class="col-12 col-md-9 ltr">
													<a class="pointer" href="{{ r.link | replacechar : '|u' : '' }}" target="_blank" ><mat-icon aria-hidden="false">picture_as_pdf</mat-icon></a>
												</td> 
											</tr>
											<tr class="row" *ngIf="r.link && intra=='false'">
												<td class="col-12 col-md-3">{{ 'lien' | translate }} :</td> 
												<td class="col-12 col-md-9 text-info"> 
													<mat-icon aria-hidden="false">warning</mat-icon>&nbsp;&nbsp; {{ 'intera' | translate }} 
												</td> 
											</tr>
											<!-- <tr class="row">
												<td class="text-center col-12">
													<a class="pointer" (click)="r.status=true" *ngIf="r.status==false" ><img src="http://www.fondation.org.ma/assets/images/3downs.png" /></a>
													<a class="pointer" (click)="r.status=false" *ngIf="r.status==true"  ><img src="http://www.fondation.org.ma/assets/images/3ups.png" /></a>
												</td>
											</tr> -->
										</tbody>
									</table>
								</th>
							</tr>
						</thead>
					</table>
				</a>
			</div>
		</div>
	</div>
	<ul class="nav nav-pills my-4 justify-content-center" *ngIf="Links">
		<li class="nav-item">
			<a class="nav-link pointer" [ngClass]="CurrentPage==0?'disabled':''" (click)="onPageRecord(1)" > <<</a>
		</li>
		<li class="nav-item">
			<a class="nav-link pointer" [ngClass]="CurrentPage==0?'disabled':''" (click)="onPageRecord(CurrentPage-1)" > < </a>
		</li>
		<li class="nav-item">
			<a class="nav-link pointer active" > {{ CurrentPage }} / {{ TotalPages }} </a>
		</li>
		<li class="nav-item">
			<a class="nav-link pointer" [ngClass]="TotalPages==CurrentPage?'disabled':''" (click)="onPageRecord(CurrentPage+1)" > > </a>
		</li>
		<li class="nav-item">
			<a class="nav-link pointer" [ngClass]="TotalPages==CurrentPage?'disabled':''" (click)="onPageRecord(TotalPages)" > >> </a>
		</li>
	</ul>	
</div>
<div class="col-12 col-xl-3 order-1"><app-filter></app-filter></div>
<div id="myModal" class="modal fade" role="dialog">
	<div class="modal-dialog">
  
	  <!-- Modal content-->
	  <div class="modal-content">
		<div class="modal-header">
		  <button type="button" class="close" data-dismiss="modal">&times;</button>
		  <h4 class="modal-title">Modal Header</h4>
		</div>
		<div class="modal-body">
		  <!--<table class="tab-manu">
			 <tbody>
				<tr class="row" *ngIf="r.title">
					<td class="bold col-12 col-md-3">{{ 'titre' | translate }} :</td> 
					<td class="bold col-12 col-md-9"> {{ r.title | selectbar : 'a' }} {{ r.title | dotpipeh : '|h' }}{{ r.title | selectbar : 'b'  }}{{ r.title | dotpipeh : '|b' }} {{ r.title | selectbar : 'c' }}  </td> 
				</tr>  -->
		</div>
	  </div>
  
	</div>
  </div>
</div>